import { render, staticRenderFns } from "./ListResponsavelUsuarioView.vue?vue&type=template&id=38f59e30&scoped=true&"
import script from "./ListResponsavelUsuarioView.vue?vue&type=script&lang=ts&"
export * from "./ListResponsavelUsuarioView.vue?vue&type=script&lang=ts&"
import style0 from "./ListResponsavelUsuarioView.vue?vue&type=style&index=0&id=38f59e30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f59e30",
  null
  
)

export default component.exports